import { InMemoryCache } from '@apollo/client'

export default new InMemoryCache({
  possibleTypes: {
    FeedItem: ['Event', 'Trigger'],
  },
})
